module.exports = __webpack_public_path__ + "static/media/sweet_3_tablet.bafa12e6.png";